import React, { useContext, useRef } from "react";
import { Token as TokenModel } from "../../model/structure";
import { MouseDragTokenContext } from "../../contexts";
import { MentionModel } from "../../communication";

interface TokenProps extends TokenModel {
	isHead?: boolean;
	onClick?: (event: React.MouseEvent) => void;
	unhighlight?: boolean;
	metaKeyClicked: boolean;
	shiftKeyClicked: boolean;
	currentMentionModel: MentionModel;
	hoveredSpan: string;
	setHoveredSpan: Function;
}

export function Token(props: TokenProps) {
	const token = useRef<HTMLSpanElement>(null);

	const {
		mouseDragging,
		setMouseDragging,
		shiftMouseDragging,
		setShiftMouseDragging,
		setDragStartTokenIndex,
		setDragEndTokenIndex,
		dragStartTokenIndex,
		dragEndTokenIndex,
	} = useContext(MouseDragTokenContext);

	const keyUpHandler = (e: KeyboardEvent) => {
		if (e.key === "Meta") {
			document.removeEventListener("mouseup", mouseUpHandler);
			document.removeEventListener("keyup", keyUpHandler);
			setMouseDragging((dragging) => {
				if (dragging) {
					return false;
				}
			});
			setShiftMouseDragging((shiftDragging) => {
				if (shiftDragging) {
					return false;
				}
			});
		}
		if (e.key === "Shift" && shiftMouseDragging) {
			document.removeEventListener("mouseup", mouseUpHandler);
			document.removeEventListener("keyup", keyUpHandler);
			setShiftMouseDragging(false);
		}
	};

	const mouseUpHandler = (e: MouseEvent) => {
		document.removeEventListener("mouseup", mouseUpHandler);
		document.removeEventListener("keyup", keyUpHandler);
		setMouseDragging((dragging) => {
			if (dragging) {
				return false;
			}
		});
		setShiftMouseDragging((shiftDragging) => {
			if (shiftDragging) {
				return false;
			}
		});
	};

	const mouseDownHandler = (e: React.MouseEvent) => {
		if (e.metaKey || e.ctrlKey) {
			if (e.shiftKey) {
				setShiftMouseDragging(true);
			} else {
				setMouseDragging(true);
			}
			setDragEndTokenIndex(props.tokenIndex);
			setDragStartTokenIndex(props.tokenIndex);
			document.addEventListener("keyup", keyUpHandler);
			document.addEventListener("mouseup", mouseUpHandler);
		}
	};

	const mouseOverHandler = (e: React.MouseEvent) => {

		if (
			((e.metaKey || e.ctrlKey) && !e.shiftKey && mouseDragging) ||
			((e.metaKey || e.ctrlKey) && e.shiftKey && shiftMouseDragging)
		) {
			setDragEndTokenIndex(props.tokenIndex);
		}
	};

	const mouseDragEndHandler = (e: React.MouseEvent) => {
		if (e.metaKey || e.ctrlKey) {
			if (!e.shiftKey && (mouseDragging || shiftMouseDragging)) {
				setDragEndTokenIndex(props.tokenIndex);
				setMouseDragging(false);
			} else if (e.shiftKey && shiftMouseDragging) {
				setDragEndTokenIndex(props.tokenIndex);
				setShiftMouseDragging(false);
			}
		}
	};

	let className = "token-text";

	if (props.unhighlight !== undefined && props.unhighlight)
		className += " unhighlight";

	const [startToken, endToken] = [
		Math.min(dragStartTokenIndex, dragEndTokenIndex),
		Math.max(dragStartTokenIndex, dragEndTokenIndex),
	];
	if (
		(mouseDragging || shiftMouseDragging) &&
		props.tokenIndex >= startToken &&
		props.tokenIndex <= endToken
	) {
		className += " underCreation";
	} else if (props.metaKeyClicked) {
		className += " metaKeyActive";
	}

	if (props.currentMentionModel === "entity") {
		className += " entity";
	} else {
		className += " situation";
	}

	return (
		<span
			className={className}
			onClick={props.onClick}
			onMouseDown={mouseDownHandler}
			onMouseOver={mouseOverHandler}
			onMouseUp={mouseDragEndHandler}
			ref={token}>
			{props.text}
		</span>
	);
}
